import { render } from "./EventCard.vue?vue&type=template&id=5d48915e&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=5d48915e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5d48915e"

export default script